import { render, staticRenderFns } from "./DedicatedOutboundNumber.vue?vue&type=template&id=0b4f89d1&"
import script from "./DedicatedOutboundNumber.vue?vue&type=script&lang=js&"
export * from "./DedicatedOutboundNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect});
